import { render, staticRenderFns } from "./VideoLibrary.vue?vue&type=template&id=0597426c&scoped=true&lang=pug"
import script from "./VideoLibrary.vue?vue&type=script&lang=js"
export * from "./VideoLibrary.vue?vue&type=script&lang=js"
import style0 from "./VideoLibrary.vue?vue&type=style&index=0&id=0597426c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0597426c",
  null
  
)

export default component.exports